<template>
  <div>
    <button @click="showModal" class="btn btn-primary btn-sm">Agregar</button>
    <b-modal
      id="modal-attach-to-branch"
      header-class="align-items-center bg-primary py-2"
      title="Agregar Empleado"
      title-class="h3 text-white"
      hide-footer
    >
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          placeholder="Buscar por nombre"
          autofocus
          v-model="find"
        />
        <div class="list-group">
          <button
            v-for="(emp, ke) in elements"
            :key="ke"
            @click="attach(emp)"
            class="list-group-item list-group-item-action"
          >
            {{ emp.nombre }}
          </button>
        </div>
      </div>
      <!-- <b-form @submit="save" @reset="onReset">
        <b-form-group label="Código">
          <b-form-input type="text" v-model="form.codigo"></b-form-input>
        </b-form-group>
        <b-form-group label="Nombre">
          <b-form-input type="text" v-model="form.nombre"></b-form-input>
        </b-form-group>
        <b-form-group label="Domicilio">
          <b-form-input type="text" v-model="form.domicilio"></b-form-input>
        </b-form-group>
        <b-button
          type="submit"
          :disabled="working"
          variant="primary"
          class="float-right"
          size="sm"
          >Guardar</b-button
        >
      </b-form> -->
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "attach-to-branch",
  props: {
    branchId: Number,
  },
  data: () => {
    return {
      working: false,
      find: "",
      elements: [],
    };
  },
  watch: {
    find: function (val) {
      this.getEmpleados(val);
    },
  },
  methods: {
    showModal() {
      this.$bvModal.show("modal-attach-to-branch");
    },
    getEmpleados(find = null) {
      if (!find) {
        this.elements = [];
        return;
      }

      this.$api
        .get(`empleados?find=${find}`)
        .then((response) => {
          this.elements = response.data.rows;
        })
        .catch((e) => console.error(e));
    },
    async attach(empleado) {
      try {
        this.working = true;

        const response = await this.$api.post(
          `sucursales/${this.branchId}/empleados`,
          {
            empleadoId: empleado.id,
          }
        );

        this.find = "";

        this.$notiflix.Notify.success("Empleado asociado a la sucursal.");

        this.$emit("onAttach", empleado);
      } catch (error) {
        this.$notiflix.Report.failure(
          "Error Interno",
          "No fue posible obtener el recurso solicitado, serás dirigido al inicio y puedes intentarlo nuevamente.",
          "Entendido",
          () => {
            this.$router.push("/");
          }
        );
      }
    },
  },
};
</script>
